import type { AnyCodeDictionary } from '@mypoz/i18n';

/**
 * Order status codes.
 *
 * `order_status_list` is the one endpoint in the whole API that returns an English twin
 * (`status_en`), but we deliberately do not use it: keying one domain off the backend's English
 * and every other domain off our catalogs would mean two mechanisms, and it still leaves Malay
 * unanswered. So order statuses are authored here like everything else.
 *
 * ORDERED carries a label in the doc (已下单); PACK appears in the `order_list` example without
 * one. Nothing else is evidenced — "END", which looks like an order state, is actually an FPX
 * payment-transaction status. Complete this from the live `order_status` endpoint rather than
 * guessing; an unregistered code falls back to the raw value, a wrong entry does not.
 */
export const ORDER_STATUS = [
  { code: 'ORDERED', labelKey: 'dict.orderStatus.ordered' }, // 已下单 — order_status_list
  { code: 'PACK', labelKey: 'dict.orderStatus.pack' }, // order_list example
] as const satisfies AnyCodeDictionary;

/**
 * How a channel turns a parcel into a chargeable figure — `calcweightway` on the wire, live values
 * WEIGHT / VOL / BAG. Replaces the invented `CHANNEL_RESTRICTION` dictionary this file carried
 * before MYP-53 slice 2: `channels` has no closed set of restriction codes to key off (the
 * per-channel warning is free text — see `ShippingChannel.notice`), but it does have this closed,
 * genuinely-coded field, so it gets the dictionary treatment the restriction guess wrongly claimed.
 */
export const WEIGHT_BASIS = [
  { code: 'WEIGHT', labelKey: 'dict.weightBasis.weight' },
  { code: 'VOL', labelKey: 'dict.weightBasis.vol' },
  { code: 'BAG', labelKey: 'dict.weightBasis.bag' },
] as const satisfies AnyCodeDictionary;
